<template>
   <el-dialog custom-class="dialog-wrapper" title="跳过手机绑定开关" :close-on-click-modal="false" :modal-append-to-body="false"
      v-model="dialogVisible">
      <el-form :inline="true">
         <div class="margin-bottom-10" v-for="(item, index) in configList" :key="index">
            <el-form-item label="类型">
               <el-select v-model="configList[index].type">
                  <el-option v-for="(item, index) in typeOptions" :key="index" :label="item.label" :value="item.value">
                  </el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="版本号">
               <el-input v-model="configList[index].version"></el-input>
            </el-form-item>
            <el-button v-if="index == 0" type="primary" @click="clickAddConfig">添加</el-button>
            <el-button v-if="index != 0" type="danger" icon="delete" @click="clickDeleteConfig(index)"></el-button>
         </div>
      </el-form>
      <template #footer>
         <div class="flex-row-center">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="clickEditDone">确定</el-button>
         </div>
      </template>
   </el-dialog>
</template>

<script>
export default {
   props: {
      typeOptions: [],
      dataSource: {}
   },

   data() {
      return {
         dialogVisible: false,
         configList: [{ type: '', version: '' }]
      }
   },

   methods: {
      // 发送更新
      sendUpdate() {
         const resValue = this.configList.filter((item) => {
            return item.type && item.type !== '' && item.version && item.version !== '';
         }).map((item) => {
            return item.type + ':' + item.version
         }).join(',');
         const param = {
            tag: this.dataSource.tag,
            key: this.dataSource.resKey,
            value: resValue
         };
         this.$http({
            url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
            method: "POST",
            dataType: "json",
            body: JSON.stringify(param)
         }).then((res) => {
            if (res.data.error === 10000) {
               this.dialogVisible = false;
               this.$emit('refresh');
            } else {
               this.$util.errorMsg(res.message);
            }
         }).catch((error) => {
            this.$util.errorMsg('获取详情信息失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 点击编辑
      clickEdit() {
         if (!this.dataSource.resValue) {
            this.configList = [{ type: '', version: '' }];
         } else {
            const list = this.dataSource.resValue.split(',');
            this.configList = list.map((item) => {
               const tmpArr = item.split(':');
               return {
                  type: tmpArr[0] || '',
                  version: tmpArr[1] || ''
               }
            });
         }
         this.dialogVisible = true;
      },

      // 点击添加配置
      clickAddConfig() {
         this.configList.push({ type: '', version: '' });
      },

      // 点击删除配置
      clickDeleteConfig(index) {
         this.configList.splice(index, 1);
      },

      // 点击编辑弹框确认
      clickEditDone() {
         this.sendUpdate();
      },

   }
}
</script>

<style scoped>
.el-select {
   width: 200px;
}

.el-input {
   width: 200px;
}
</style>


// WEBPACK FOOTER //
// SkipPhoneBinding.vue?7fcc29d6